import { gql } from 'apollo-boost';

export const getPageCategoriesQuery = gql`
  query Categories($type: CategoryType!) {
    Categories(input: { type: $type }) {
      id
      title
    }
  }
`;

export const getPagePreviewCategoriesQuery = gql`
  query CategoriesPreview($pageName: String!, $type: CategoryType!) {
    CategoriesPreview(input: { pageName: $pageName, type: $type }) {
      id
      title
    }
  }
`;

export const newCategoryQuery = gql`
  mutation NewCategory($title: String!, $type: CategoryType!) {
    NewCategory(input: { title: $title, type: $type }) {
      id
      title
    }
  }
`;

export const editCategoryQuery = gql`
  mutation EditCategory($id: ID!, $title: String!, $type: CategoryType!) {
    EditCategory(input: { id: $id, title: $title, type: $type }) {
      id
      title
    }
  }
`;

export const removeCategoryQuery = gql`
  mutation RemoveCategory($id: ID!) {
    RemoveCategory(input: { id: $id })
  }
`;
